import { BusinessRules } from '../BusinessRules';
import compMsgDebitoEmConta from '../components/nubank/compMsgDebitoEmConta.vue';
import compMsgEmissaoParcelaSuspensa from '../components/nubank/compMsgEmissaoParcelaSuspensa.vue';

const rules: Partial<BusinessRules> = {
  mensagemTermoCondicoesGerais: 'O valor da dívida exibido é calculado com base no prazo máximo do canal de pagamento escolhido. Ao continuar, você declara que leu e concorda com as informações descritas no documento de',
  compMsgDebitoEmConta,
  compMsgEmissaoParcelaSuspensa,
  nomeAplicativo: 'Nubank',
  linkCanalOficial: 'https://nubank.com.br/',
  mensagemAcompanhamentoAplicativo: 'Após o pagamento da primeira parcela, o restante da sua negociação poderá ser acompanhado diretamente no canal Nubank.',
  mensagemColchaoNaoGerenciado: 'Todas as atualizações das negociações com o Nubank devem ser acompanhadas exclusivamente através do seu portal. Nele você encontrará informações detalhadas sobre o status dos seus pagamentos.',
  showLogoTelaBoletos: (p) => p?.parcelasGerenciadas?.demaisParcelas === false
    && (p.parcelasGerenciadas.primeiraParcela === false
      || p.parcelas?.find((b) => b.numeroParcela === 1)?.quitada === true),
};

export default rules;
